import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import { NotifyHelper } from 'vue-kit'
import PriceConfig from '@/dto/price_config/PriceConfig'
import PriceConfigService from '@/services/PriceConfigService'

@DynamicModule
class PriceConfigStore extends VuexModule {
  public priceConfigs: PriceConfig[] = []
  public priceConfigId: number | null = null

  get priceConfig(): PriceConfig | null {
    if (!this.priceConfigId) {
      return null
    }

    return (
      this.priceConfigs.find(config => config.id === this.priceConfigId) || null
    )
  }

  @Mutation
  selectPriceConfig(priceConfigId: number | null) {
    this.priceConfigId = priceConfigId
  }

  @Mutation
  setPriceConfigs(configs: PriceConfig[]) {
    this.priceConfigs = configs
  }

  @Mutation
  addPriceConfig(priceConfig: PriceConfig) {
    this.priceConfigs.unshift(priceConfig)
  }

  @Mutation
  public updatePriceConfigInList(model: PriceConfig) {
    const index = this.priceConfigs.findIndex(
      priceConfig => priceConfig.id === model.id
    )
    this.priceConfigs.splice(index, 1, model)
  }

  @Mutation
  deletePriceConfigFromList(priceConfigId: number) {
    const index = this.priceConfigs.findIndex(
      config => config.id === priceConfigId
    )
    this.priceConfigs.splice(index, 1)
  }

  @Action({ rawError: true })
  async savePriceConfig(model: PriceConfig) {
    return PriceConfigService.savePriceConfig(model)
      .then(priceConfig => {
        NotifyHelper.success('Настройка цен и весов сохранена')

        if (model.id) {
          this.updatePriceConfigInList(priceConfig)
        } else {
          this.addPriceConfig(priceConfig)
        }
        return priceConfig
      })
      .catch(error => {
        throw error.response.data.errors
      })
  }

  @Action({ rawError: true })
  async deletePriceConfig(priceConfigId: number) {
    return PriceConfigService.deletePriceConfig(priceConfigId)
      .then(() => {
        this.deletePriceConfigFromList(priceConfigId)
        NotifyHelper.success('Настройка цен удалена')
      })
      .catch(() => NotifyHelper.error('Ошибка сервера'))
  }

  @Action({ rawError: true })
  async loadPriceConfigs() {
    return PriceConfigService.loadPriceConfigs()
      .then(priceConfigs => {
        this.setPriceConfigs(priceConfigs)
      })
      .catch(error => {
        NotifyHelper.error(error.response.data.errors)
      })
  }
}

export default getModule(PriceConfigStore)
